/**
 * Sort utility functions for tables and lists
 */

/**
 * Generic sort function for array of objects
 * @param {Array} data - Array to sort
 * @param {string} sortKey - Key to sort by
 * @param {string} sortDir - Sort direction ('asc' or 'desc')
 * @param {Array} dateFields - Array of field names that should be treated as dates
 * @returns {Array} Sorted array
 */
export const sortData = (data, sortKey, sortDir = 'asc', dateFields = []) => {
  return [...data].sort((a, b) => {
    const aVal = a[sortKey] || ''
    const bVal = b[sortKey] || ''

    // Handle date fields
    if (dateFields.includes(sortKey)) {
      const aDate = new Date(aVal)
      const bDate = new Date(bVal)
      return sortDir === 'asc' ? aDate - bDate : bDate - aDate
    }

    // Handle string/number fields
    return sortDir === 'asc'
      ? String(aVal).localeCompare(String(bVal))
      : String(bVal).localeCompare(String(aVal))
  })
}

/**
 * Toggle sort direction
 * @param {string} currentKey - Current sort key
 * @param {string} newKey - New sort key
 * @param {string} currentDir - Current sort direction
 * @returns {Object} { key, dir }
 */
export const toggleSortDirection = (currentKey, newKey, currentDir) => {
  if (currentKey !== newKey) {
    return { key: newKey, dir: 'asc' }
  }
  return { key: newKey, dir: currentDir === 'asc' ? 'desc' : 'asc' }
}

/**
 * Sort locations by order and name
 * @param {Array} locations - Array of location objects
 * @returns {Array} Sorted locations
 */
export const sortLocations = (locations) => {
  return [...locations].sort((a, b) => {
    if (a.order !== undefined && b.order !== undefined) {
      return a.order - b.order
    }
    return (a.name || '').localeCompare(b.name || '')
  })
}
